import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IModelViewExterior, IModelViewInterior, ModelViewerSpot } from '@ncg/data';
import { TranslatePipe } from '@ngx-translate/core';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { SpinnerModule } from '../../spinner/spinner.module';
import { TabsModule } from '../../tabs/tabs.module';
import { UtilsModule } from '../../utils/utils.module';
import { ModelViewerExteriorComponent } from './model-viewer-exterior.component';
import { ModelViewerInteriorComponent } from './model-viewer-interior.component';

@Component({
    imports: [
        CommonModule,
        SpinnerModule,
        UtilsModule,
        TabsModule,
        IconSpriteModule,
        TranslatePipe,
        ModelViewerExteriorComponent,
        ModelViewerInteriorComponent,
    ],
    selector: 'ncg-model-viewer-container',
    template: `
        <div class="model-viewer-container" ncgLoadIn>
            <ng-container *ngIf="isSingleView">
                <ncg-model-viewer-exterior *ngIf="exteriorView" [exteriorView]="exteriorView"></ncg-model-viewer-exterior>
                <ncg-model-viewer-interior *ngIf="interiorView" [interiorView]="interiorView"></ncg-model-viewer-interior>
            </ng-container>

            <ncg-tab-group *ngIf="!isSingleView">
                <ncg-tab [isActive]="true" [label]="'model_viewer_spot.exterior_view' | translate">
                    <ncg-model-viewer-exterior [exteriorView]="exteriorView!"></ncg-model-viewer-exterior>
                </ncg-tab>
                <ncg-tab [label]="'model_viewer_spot.interior_view' | translate">
                    <ncg-model-viewer-interior [interiorView]="interiorView!"></ncg-model-viewer-interior>
                </ncg-tab>
            </ncg-tab-group>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelViewerContainerComponent {
    @Input()
    public set modelViewer(data: ModelViewerSpot) {
        this.exteriorView = data.exteriorView;
        this.interiorView = data.interiorView;
        if (this.exteriorView?.length && this.interiorView?.length) {
            this.isSingleView = false;
        }
    }

    public exteriorView?: IModelViewExterior[];
    public interiorView?: IModelViewInterior[];
    public isSingleView = true;
}
